'use client';

import { createContext, FC, ReactNode } from 'react';

import { Page } from '@rover/types';

const PageContext = createContext<Page | null>(null);

export type PageContextProviderProps = {
  value: Page | null;
  children: ReactNode;
};

// This provides a named export for the Provider, allowing import by server components
export const PageContextProvider: FC<PageContextProviderProps> = (props) => (
  <PageContext.Provider {...props} />
);

export default PageContext;
